export const convertContentfulRawCopyToMap = (content) =>
  content.reduce((acc, curr) => {
    acc[curr.fields.slug] = curr.fields.text;

    return acc;
  }, {});

export default null;
